import React from 'react'
import moment from 'moment'
import { RawSelect, useHandler } from 'labguard-cdk'
import { durations } from 'src/services/period'
import { usePeriodState } from 'src/hooks'
import { NowContext } from 'src/contexts'
import styles from './RelativePeriodInput.scss'

const RelativePeriodInput = props => {
  // get current period and updater
  const [{ from, to }, updatePeriod] = usePeriodState()
  // get current time
  const { now } = NowContext.use()
  // compute duration
  const value = React.useMemo(() => now.getTime() - from.getTime(), [now, from])
  // use value updater
  const onChange = useHandler(duration => updatePeriod({ from: new Date(now.getTime() - duration) }))
  // get label associated to current value
  const label = React.useMemo(() => moment.duration(value).humanize(), [value])
  // create array of options
  const options = React.useMemo(
    () =>
      durations
        .map(value => ({ value, label: moment.duration(value).humanize() }))
        .filter(duration => to || duration.label !== label)
        .concat(to ? [] : [{ value, label, selected: true }])
        .sort((a, b) => a.value - b.value),

    [value, to, label]
  )

  return (
    <RawSelect className={styles.select} onChange={onChange} value={to ? '' : value} {...props}>
      <option value="" disabled>
        {to ? moment.duration(to - from).humanize() : '-------'}
      </option>

      {options.map(({ value, label }) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </RawSelect>
  )
}

RelativePeriodInput.defaultProps = {
  color: 'white',
}

export default RelativePeriodInput
